<template>
    <div class="container mx-auto px-4 py-6">
      <!-- Botón para abrir el modal -->
        <div v-if="canView('superadministrador', 'administradorevento')" class="boton-svg">
          <button @click="showModalButtons = true" class="modal-trigger-button">            
              <IconoEngraneConfiguraciones></IconoEngraneConfiguraciones>
          </button>
        </div>
        <div class="boton-tutorial">
          <a target="_blank" href="http://qr.codes/5pHJeN">Tutorial</a>
        </div>
        <!-- Modal que contiene los botones -->
        <div v-if="showModalButtons" class="modal">
        <div class="modal-content">
            <div v-if="canView('superadministrador')" class="botones">
                <AgregarSuperAdministrador @userCreated="fetchGroups" :eventoToken="eventoToken" />
            </div>
            <div v-if="canView('superadministrador', 'administradorevento')" class="botones">
                <a target="_blank" class="boton-front bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded w-full" :href="`/check-status-event/${eventoToken}`">Resumen evento</a>
                <CreateGroupModal v-if="!fechaCorte" @groupCreated="fetchGroups" :eventoToken="eventoToken" />
                <CargaGrupos v-if="!fechaCorte" @groupCreated="fetchGroups" :eventoToken="eventoToken" />
                <a target="_blank" class="boton-front bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded w-full" :href="`/approve-users/${eventoToken}`">Aprobación de usuarios</a>
                <AgregarAdministradorEvento v-if="!fechaCorte" @userCreated="fetchGroups" :eventoToken="eventoToken" />
                <EnvioMagicLinksEvento v-if="!fechaCorte"  :eventoToken="eventoToken" />
            </div>
            <button @click="showModalButtons = false" class="mt-2 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">Cerrar</button>
        </div>
        </div>
      <h2 class="text-xl font-semibold text-gray-800 mb-4">Lista de Usuarios por Grupo</h2>

      <DownloadButton v-if="!fechaCorte" :camposObligatorios="camposObligatorios" />

      <div v-if="loading">
        Cargando usuarios...
      </div>
      <div v-else style="width: 100%">
        <div v-for="group in groups" :key="group.group_id" class="mb-4 p-4 bg-white shadow-md rounded-lg">
          <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg titulo-grupo font-bold">
              <EditGroupModal
                v-if="canView('superadministrador','administradorevento') && !fechaCorte && group.grupo_activo == 1"
                :group="group"
                v-model:staff="group.staff"
                v-model:asistentes="group.asistentes"
                v-model:conferencistas="group.conferencistas"
                @groupUpdated="handleGroupUpdated"
                @groupDeleted="handleGroupDeleted"
              />
              <EnvioMagicLinksGrupo  v-if="canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" :grupoToken="group.group_id"/>
              <CerrrarGrupo  v-if="canView('superadministrador','administradorevento') && !fechaCorte && group.grupo_activo == 1 && !groupsModified[group.group_id]" :grupoToken="group.group_id" />
              <div v-if="canView('superadministrador','administradorevento') && group.grupo_activo == 0 && !groupsModified[group.group_id]" :grupo-token="group.group_id">
                <button @click="descargarCSV(group)" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded">
                     CSV 
                </button>
                <button @click="descargarXLSX(group)" class="ml-2 bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-3 rounded">
                     XLSX 
                </button>
            </div>

              <!-- <CerrrarGrupo  v-if="canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" :grupoToken="group.group_id"/> -->
              {{ group.group_name }}
            </h3>
            <div>
              <button v-if="canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" @click="addUser(group.group_id)" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded">Agregar Moderador</button>
            </div>
          </div>          
            <TablaAdministradores :grupo-token="group.group_id" :fechaCorte="fechaCorte" :grupo_activo="group.grupo_activo" :group="group" @user-deleted="handleUserDeleted"></TablaAdministradores>                      
            
            <TablaInvitados
            v-if="Number(group.staff) > 0"
            :group="group"
            :group-id="group.group_id"
            :grupo_activo="group.grupo_activo"
            :eventoToken="eventoToken"
            :groupName="group.group_name"
            category="staff"
            title="Staff"
            :count="group.staff"
            :fechaCorte="fechaCorte"
            :members="group.staff_members.staff"
            :visible="Number(group.staff) > 0"
            :loading="excelLoading.group_id === group.group_id && excelLoading.category === 'staff'"
            :is-open="isAccordionOpen(group.group_id, 'staff')"
            :campos-obligatorios="camposObligatorios"
            :groupsModified="groupsModified"
            @solicitud-modificacion="markGroupAsModified"
            @trigger-file-input="triggerFileInput"
            @file-changed="handleFileChange"
            @toggle-accordion="toggleAccordion"
            @perform-save="performSaveStaffMembers"
            @approve-user="approveUser"
            @show-modal="showModal"
            @group-modified="markGroupAsModified"
            />

            <TablaInvitados
            v-if="Number(group.conferencistas) > 0"
                :group="group"
                :group-id="group.group_id"
                :grupo_activo="group.grupo_activo"
                :eventoToken="eventoToken"
                :groupName="group.group_name"
                category="conferencistas"
                title="Expositores"
                :count="group.conferencistas"
                :fechaCorte="fechaCorte"
                :members="group.staff_members.conferencistas"
                :visible="Number(group.conferencistas) > 0"
                :loading="excelLoading.group_id === group.group_id && excelLoading.category === 'conferencistas'"
                :is-open="isAccordionOpen(group.group_id, 'conferencistas')"
                :campos-obligatorios="camposObligatorios"
                :groupsModified="groupsModified"
                @solicitud-modificacion="markGroupAsModified"
                @trigger-file-input="triggerFileInput"
                @file-changed="handleFileChange"
                @toggle-accordion="toggleAccordion"
                @perform-save="performSaveConferencistas"
                @approve-user="approveUser"
                @show-modal="showModal"
                @group-modified="markGroupAsModified"
            />
            
            <TablaInvitados
            v-if="Number(group.asistentes) > 0"
                :group="group"
                :group-id="group.group_id"
                :grupo_activo="group.grupo_activo"
                :eventoToken="eventoToken"
                :groupName="group.group_name"
                category="asistentes"
                title="Asistentes"
                :count="group.asistentes"
                :fechaCorte="fechaCorte"
                :members="group.staff_members.asistentes"
                :visible="Number(group.asistentes) > 0"
                :loading="excelLoading.group_id === group.group_id && excelLoading.category === 'asistentes'"
                :is-open="isAccordionOpen(group.group_id, 'asistentes')"
                :campos-obligatorios="camposObligatorios"
                :groupsModified="groupsModified"
                @solicitud-modificacion="markGroupAsModified"
                @trigger-file-input="triggerFileInput"
                @file-changed="handleFileChange"
                @toggle-accordion="toggleAccordion"
                @perform-save="performSaveAsistentes"
                @approve-user="approveUser"
                @show-modal="showModal"
                @group-modified="markGroupAsModified"
            />                 

            <!-- <button v-if="!fechaCorte && group.grupo_activo == 1" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded" @click="performSaveAllMembers(group)">Guardar Todos</button> -->
        </div>
      </div>
      <div class="flex justify-between items-center mt-4" v-if="pager.totalPages > 1">
        <button :disabled="pager.currentPage === 1" 
                @click="fetchGroups(pager.currentPage - 1)"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50">
            Anterior
        </button>
        <span>Página {{ pager.currentPage }} de {{ pager.totalPages }}</span>
        <button :disabled="pager.currentPage === pager.totalPages"
                @click="fetchGroups(pager.currentPage + 1)"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50">
            Siguiente
        </button>
        </div>
         <!-- Modal de confirmación -->
        <div v-if="showConfirmationModal" class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"></span>

            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div class="sm:flex sm:items-start">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                    <IconoAtencionModal></IconoAtencionModal>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg leading-6 font-medium text-gray-900 mt-2">
                        Atención
                        </h3>
                        <br>
                        <p>
                        Cargando <b>{{ selectedCategory === 'conferencistas' ? 'Expositores' : selectedCategory }}</b>
                        </p>
                        <div class="mt-2">
                        <p class="text-sm text-gray-500">
                            Al cargar una base de datos se reemplazarán los datos de los {{ selectedCategory === 'conferencistas' ? 'Expositores' : selectedCategory }} que ya tenga guardados para esta lista de usuarios.
                        </p>
                        </div>

                </div>
                </div>
                <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button @click="confirmUpload" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                    OK, CARGAR
                </button>
                <button @click="cancelUpload" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
                    CANCELAR
                </button>
                </div>
            </div>
            </div>
             <!-- Modal de Confirmación -->
            </div>
        <ModalConfirm
            :is-visible="isModalVisible"
            title="Confirmación de Borrado"
            message="¿Estás seguro de que deseas borrar este miembro?"
            @confirm="clearMember"
            @cancel="closeModal"
        ></ModalConfirm>
    </div>
  </template>

<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import EditGroupModal from '@/components/modals/groupModal/EditGroupModal.vue';
import CreateGroupModal from '@/components/modals/groupModal/CreateGroupModal.vue';
import CargaGrupos from '@/components/CargaGrupos/CargaGrupos.vue';
import { useToast } from "vue-toastification";
import DownloadButton from '@/components/DownloadButton.vue';
import AgregarAdministradorEvento from '@/components/administracion/AgregarAdministradorEvento.vue';
import AgregarSuperAdministrador from '@/components/administracion/AgregarSuperAdministrador.vue';
import ModalConfirm from '@/components/modals/ModalConfirm.vue';
import IconoEngraneConfiguraciones from './svgs/IconoEngraneConfiguraciones.vue';
import IconoAtencionModal from './svgs/IconoAtencionModal.vue';
import TablaAdministradores from './tablas/TablaAdministradores.vue';
import TablaInvitados from './tablas/TablaInvitados.vue';
import EnvioMagicLinksEvento from '@/components/administracion/EnvioMagicLinksEvento.vue';
import EnvioMagicLinksGrupo from '@/components/administracion/EnvioMagicLinksGrupo.vue';
import CerrrarGrupo from '@/components/administracion/CerrrarGrupo.vue';
// import { createLogger } from 'vuex';
// import { createLogger } from 'vuex';
import { fillExistingData } from './metodos/InicializarValidarMiembros.js'; // Ajusta la ruta del archivo correctamente
import { saveAllMembers, saveStaffMembers, saveConferencistas, saveAsistentes } from './services/saveMembersService.js';
import { reactive } from 'vue';

export default {
  name: 'ListaGruposUsuarios',
  props: {
    eventoToken: {
      type: String,
      required: true
    },
    grupoToken: {
        type: String,
        default: null // ya que es opcional, podrías proporcionar un valor por defecto
    }
  },
  setup() {      
      const toast = useToast();
      return { toast }
    },
  data() {
    return {
      groups: [],
      loading: true,
      role: null,
      excelLoading: {
        group_id: null,
        category: ''
      },
      expandedGroup: null,
      expandedCategory: null,      
      pager: {
        currentPage: 1,
        totalPages: 0
      },
      showConfirmationModal: false,
      selectedGroupId: null,
      selectedCategory: '',
      selectedFile: null,
      isModalVisible: false,
      currentGroup: null,
      currentCategory: null,
      currentIndex: null,
      showModalButtons: false,
      infoEvento: [],
      validarMandatorio: false,
      camposObligatorios: [],
      roleLoaded: false,
      fechaResponse: null,
      fechaCorte: false,
      groupsModified: reactive({}),  
    };
  },
  components: {
    CreateGroupModal,
    EditGroupModal,
    CargaGrupos,
    DownloadButton,
    AgregarAdministradorEvento, // Añade aquí tu nuevo componente
    AgregarSuperAdministrador, // Añade aquí tu nuevo componente
    ModalConfirm,    
    EnvioMagicLinksEvento,
    EnvioMagicLinksGrupo,
    IconoEngraneConfiguraciones,    
    CerrrarGrupo,
    IconoAtencionModal,
    TablaAdministradores,
    TablaInvitados

  },
  provide() {
    return {
      canView: this.canView,
      canApproveComputed: this.canApproveComputed 
    };
  },
  computed: {      
    roleToken() {
      return this.$store.state.roleToken;
    },
    canApproveComputed() {
        return (user) => {
            return user && !user.isModified && user.isSaved;
        };
    },

  },
  watch: {
    'pager.currentPage'(newPage) {
        this.fetchGroups(newPage);
    }
  },

  methods: {

    descargarCSV(group) {
    const rows = [
      ['Nombres', 'Apellidos', 'Número de Documento', 'Correo Electrónico', 'Tipo de Documento', 'Teléfono', 'Ciudad', 'País', 'Departamento', 'Categoría', 'Empresa', 'Profesion', 'especialidad', 'direccion', 'indicativo_de_telefono']
    ];
    ['staff', 'conferencistas', 'asistentes'].forEach(category => {
      group.staff_members[category].forEach(member => {
        rows.push([
          member.nombres,
          member.apellidos,
          member.numero_de_documento,
          member.correo_electronico,
          member.tipo_de_documento,
          member.telefono,
          member.ciudad,
          member.pais,
          member.departamento,
          member.categoria,
          member.empresa,
          member.profesion,
          member.especialidad,
          member.direccion,
          member.indicativo_de_telefono,
        ]);
      });
    });
    let csvContent = "data:text/csv;charset=utf-8," 
      + rows.map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `grupo-${group.group_id}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  descargarXLSX(group) {
    const wb = XLSX.utils.book_new();
    ['staff', 'conferencistas', 'asistentes'].forEach(category => {
      const ws_data = [
        ['Nombres', 'Apellidos', 'Número de Documento', 'Correo Electrónico', 'Tipo de Documento', 'Teléfono', 'Ciudad', 'País', 'Departamento', 'Categoría', 'Empresa', 'Profesion', 'especialidad', 'direccion', 'indicativo_de_telefono']
      ];
      group.staff_members[category].forEach(member => {
        ws_data.push([
          member.nombres,
          member.apellidos,
          member.numero_de_documento,
          member.correo_electronico,
          member.tipo_de_documento,
          member.telefono,
          member.ciudad,
          member.pais,
          member.departamento,
          member.categoria,
          member.empresa,
          member.profesion,
          member.especialidad,
          member.direccion,
          member.indicativo_de_telefono,
        ]);
      });
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      XLSX.utils.book_append_sheet(wb, ws, category);
    });
    XLSX.writeFile(wb, `grupo-${group.group_id}.xlsx`);
  },
    markGroupAsModified(group_id) {
      this.groupsModified[group_id] = true;
    },
    async resetGroupModification(group_id) {
        // Usar Object.hasOwnProperty.call para verificar si la propiedad existe
        console.log('desde funcion para activar boton' + group_id)
        if (Object.prototype.hasOwnProperty.call(this.groupsModified, group_id)) {
            delete this.groupsModified[group_id];  // Elimina la propiedad del objeto reactivo
            this.groupsModified = {...this.groupsModified};  // Reasigna el objeto para asegurar reactividad
        }
    },

    canApprove(user) {
        return user && !user.isModified && user.isSaved;
    },

    triggerFileInput(groupId, category) {
        this.selectedGroupId = groupId;
        this.selectedCategory = category;
        const fileInput = document.getElementById('file-input-' + category + '-' + groupId);
        this.excelLoading = { group_id: groupId, category: category }; // Configurar la carga
        fileInput.click();
    },
    

    
    toggleAccordion(groupId, category) {
        if (this.expandedGroup === groupId && this.expandedCategory === category) {
        this.expandedGroup = null;
        this.expandedCategory = null;
        } else {
        this.expandedGroup = groupId;
        this.expandedCategory = category;
        }
    },

    isAccordionOpen(groupId, category) {
        return this.expandedGroup === groupId && this.expandedCategory === category;
    },
// Dentro de un método
    
    fetchGroups(page = 1) {
        const token = this.$store.state.user.token;
        let url = `/api/usuarios/${this.eventoToken}`;
        if (this.grupoToken) {
            url += `/${this.grupoToken}`; // Construye la URL con el ID del grupo si está presente
        }
        axios.post(url, {
            Authorization: `${token}`, 
            page: page 
        })
        .then(response => {
            this.infoEvento = response.data.evento;            
            if(this.infoEvento.permitir_duplicados == '0'){
                this.validarMandatorio = true;
            }            
            this.camposObligatorios = JSON.parse(this.infoEvento.campos_obligatorios).map(campo => {
                return {
                    label: campo.label,
                    activo: campo.activo,
                    requerido: campo.requerido,
                    mandatorio: campo.mandatorio
                };
            });
            this.camposObligatorios = JSON.parse(response.data.evento.campos_obligatorios).map(campo => {
                return {
                    label: campo.label,
                    activo: campo.activo,
                    requerido: campo.requerido,
                    mandatorio: campo.mandatorio
                };
            });            
            this.groups = response.data.groups.map(group => {
                group.staff = Number(group.staff);
                group.conferencistas = Number(group.conferencistas);
                group.asistentes = Number(group.asistentes);
                // Asegura que cada categoría de staff_members está definida y tiene los campos isModified y isSaved
                ['staff', 'conferencistas', 'asistentes'].forEach(category => {
                    group.staff_members[category] = group.staff_members[category].map(member => ({
                        ...member,
                        isModified: false,
                        isSaved: this.checkIfMemberComplete(member)
                    }));
                });
                return group;
            });

            const fechaParts = response.data.fecha.split(' ')[0].split('-'); // Divide la fecha en partes [año, mes, día]
            const fechaDeCorte = new Date(fechaParts[0], fechaParts[1] - 1, fechaParts[2]); // Crea la fecha de corte

            const fechaActual = new Date();
            fechaActual.setHours(0, 0, 0, 0); // Normaliza la fecha actual a medianoche

            this.fechaCorte = fechaActual >= fechaDeCorte;

            
            if (this.fechaCorte) {
                this.toast.info("Debido al paso de la fecha de corte no se pueden editar los registros");
            }
            this.pager = response.data.pager; // Verifica que los valores aquí son los esperados
            this.loading = false;
            this.groups = fillExistingData(this.groups);
        })
        .catch(error => {
            console.error('Error fetching groups:', error);
            this.loading = false;
            if (error.response && error.response.status === 403) {
                this.$router.push({ name: 'Forbidden' });
            }
        });
    },

    checkIfMemberComplete(member) {
        // Define los campos requeridos y verifica si están completos
        const requiredFields = ['nombres', 'apellidos', 'correo_electronico'];
        return requiredFields.every(field => member[field] && member[field].trim() !== '');
    },
    handleGroupUpdated(updatedGroup) {
        const updatedIndex = this.groups.findIndex(group => group.group_id === updatedGroup.group_id);
        if (updatedIndex !== -1) {
            this.groups[updatedIndex] = {...this.groups[updatedIndex], ...updatedGroup};
            this.toast.success('Grupo actualizado correctamente!');
        }
    },
    cleanPhoneNumber(value) {
        // Filtra el valor permitiendo solo números y los caracteres específicos
        return value.replace(/[^0-9()\-[\]+/]/g, '');
    },
    updatePhoneNumber(member, newValue) {
        member.telefono = this.cleanPhoneNumber(newValue);
    },
    getMember(group, category, index, field) {
        // Initialize the category if it does not exist
        if (!group.staff_members[category][index]) {
        this.$set(group.staff_members[category], index, { nombres: '', apellidos: '' });
        }
        return group.staff_members[category][index][field];
    },
    showModal(group, category, index) {
      this.currentGroup = group;
      this.currentCategory = category;
      this.currentIndex = index;
      this.isModalVisible = true;
    },
    clearMember() {
        if (this.currentGroup && this.currentCategory !== null && this.currentIndex !== null) {
            const member = this.currentGroup.staff_members[this.currentCategory][this.currentIndex];
            if (member && member.staff_id) {
                axios.post(`/api/delete-staff/${member.staff_id}`).then(response => {
                    if (response.data.success) {
                        const newMember = {
                            nombres: '',
                            apellidos: '',
                            numero_de_documento: '',
                            correo_electronico: '',
                            tipo_de_documento: '',
                            telefono: '',
                            ciudad: '',
                            pais: '',
                            departamento: '',
                            categoria: '',
                            estado: '',
                            empresa: '',
                            profesion: '',
                            especialidad: '',
                            direccion: '',
                            indicativo_de_telefono: '',
                            staff_id: member.staff_id // Considerar si se requiere un nuevo ID o no.
                        };
                        this.currentGroup.staff_members[this.currentCategory].splice(this.currentIndex, 1, newMember);
                        this.toast.success('Miembro reiniciado correctamente.');
                    } else {
                        this.toast.error('No se pudo reiniciar el miembro.');
                    }
                }).catch(error => {
                    console.error('Error al reiniciar el miembro:', error);
                    this.toast.error('Error al procesar la solicitud.');
                });
            }
        }
        this.closeModal();
    },

    closeModal() {
      this.isModalVisible = false;
    },
    performSaveAllMembers(group) {
        const toast = useToast();
        saveAllMembers(group, toast);
    },
    async performSaveStaffMembers(group) {
        const toast = useToast();        
        let success = await saveStaffMembers(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken);    
        if(success) {
            await this.resetGroupModification(group.group_id)
        }        
    },
    async performSaveConferencistas(group) {
        const toast = useToast();    
        let success = await saveConferencistas(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken);
        if(success) {
            await this.resetGroupModification(group.group_id)
        }        
    },
    async performSaveAsistentes(group) {        
        const toast = useToast();    
        let success = await saveAsistentes(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken);
        if(success) {
            await this.resetGroupModification(group.group_id)
        }        
    },
   

    checkPropAutorizado(member) {
        if (member && 'autorizado' in member) {
            if (member.autorizado === "1") {
                return true; // El miembro está autorizado
            } else {
                return false; // El miembro no está autorizado
            }
        } else {
            return false; // Miembro no definido o sin la propiedad 'autorizado'
        }
    },

        // Marca un usuario específico como modificado
        markUserAsModified(groupId, userId) {
            const groupIndex = this.groups.findIndex(g => g.group_id === groupId);
            const userIndex = this.groups[groupIndex].users.findIndex(u => u.id === userId);
            if (userIndex !== -1) {
            this.groups[groupIndex].users[userIndex].isModified = true;
            this.groups[groupIndex].users[userIndex].isSaved = false;
            }
        },

        // Marca un usuario específico como guardado
        saveUserData(groupId, userId) {
            const groupIndex = this.groups.findIndex(g => g.group_id === groupId);
            const userIndex = this.groups[groupIndex].users.findIndex(u => u.id === userId);
            if (userIndex !== -1) {
            axios.post('/api/save-user-data', this.groups[groupIndex].users[userIndex])
                .then(() => {
                this.groups[groupIndex].users[userIndex].isModified = false;
                this.groups[groupIndex].users[userIndex].isSaved = true;
                // Mensaje de éxito
                })
                .catch(error => {
                console.error('Error saving user data:', error);
                // Manejo de errores
                });
            }
        },


    handleFileChange(event, groupId, category) {
        const file = event.target.files[0];
        if (!file) return;
        this.selectedFile = file;
        this.selectedGroupId = groupId;
        this.selectedCategory = category;        
        this.showConfirmationModal = true;
    },

    sanitizeMemberData(member) {
      return {
        ...member,
        correo_electronico: String(member.correo_electronico || '').replace(/\s+/g, ''),
        numero_de_documento: String(member.numero_de_documento || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
      };
    },


   
    confirmUpload() {
        this.showConfirmationModal = false;
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 });
            this.prepareDataForUpload(jsonData, this.selectedGroupId, this.selectedCategory);
        };
        reader.readAsArrayBuffer(this.selectedFile);
    },


    cancelUpload() {
      this.showConfirmationModal = false;
      this.selectedFile = null;
      this.selectedGroupId = null;
      this.selectedCategory = '';
    },
    async prepareDataForUpload(data, groupId, category) {
        const group = this.groups.find(g => g.group_id === groupId);
        if (!group) {
            console.error('Grupo no encontrado');
            return;
        }
        const capacity = group[category]; // Asumiendo que `group[category]` te da la capacidad actual de esa categoría
        const formattedData = data.slice(1, capacity + 1).map(entry => ({
            nombres: entry[0] || '',
            apellidos: entry[1] || '',
            numero_de_documento: entry[2] || '',
            correo_electronico: entry[3] || '',
            tipo_de_documento: entry[4] || '',
            telefono: entry[5] || '',
            ciudad: entry[6] || '',
            pais: entry[7] || '',
            departamento: entry[8] || '',
            categoria: entry[9] || '',
            empresa: entry[10] || '',
            profesion: entry[11] || '',
            especialidad: entry[12] || '',
            direccion: entry[13] || '',
            indicativo_de_telefono: entry[14] || '',
            // Asegúrate de mantener los IDs si están disponibles
            staff_id: entry[15] || null // Asumiendo que el ID viene en la columna 11
        }));

        // Combinar los nuevos datos con los viejos, manteniendo los IDs existentes donde sea posible
        const existingMembers = group.staff_members[category];
        const updatedMembers = existingMembers.map((member, index) => {
          const incoming = index < formattedData.length ? formattedData[index] : null;
          if (incoming) {
            const sanitized = this.sanitizeMemberData(incoming);
            return { ...member, ...sanitized };
          }
          return member;
        });

        let success = false;
        try {
            // Llamada a la API para guardar los datos
            if (category === 'staff') {
                success  = await this.performSaveStaffMembers({ group_id: groupId, staff_members: { staff: updatedMembers } });
            } else if (category === 'conferencistas') {
                success  = await this.performSaveConferencistas({ group_id: groupId, staff_members: { conferencistas: updatedMembers } });
            } else if (category === 'asistentes') {
                success  = await this.performSaveAsistentes({ group_id: groupId, staff_members: { asistentes: updatedMembers } });
            }

            // Actualiza el estado local después de guardar
            this.groups = this.groups.map(g => g.group_id === groupId ? {
                ...g,
                staff_members: {
                    ...g.staff_members,
                    [category]: updatedMembers
                }
            } : g);

            if (success) {
                this.toast.success('Datos cargados y actualizados correctamente.');
                await this.resetGroupModification(group.group_id)
            } else {
                this.toast.info('B001 - Los datos se han colocado correctamente, verifique la información antes de guardar.');
            }
            document.getElementById('file-input-' + category + '-' + groupId).value = null;
            this.excelLoading = { group_id: null, category: '' }; // Resetear la carga
        } catch (error) {
            console.error('Error al guardar datos:', error);
            this.toast.error('Error al procesar la actualización. :(');
        }
    },


    addUser(groupId) {
      this.$router.push(`/dashboard/usuarios/agregar-usuario/${groupId}`);
    },
    
    async approveUser(staffId, category) {
        try {
            const response = await axios.post('/api/aprovation/staffs/check', {
                staff_member: staffId
            });

            if (response.data && response.data.success) {
                this.toast.success('Usuario aprobado correctamente.');
                // Actualiza el estado del miembro del staff en la interfaz de usuario
                this.updateStaffMember(staffId, { autorizado: '1' }, category);
            }
        } catch (error) {
            console.error('Error al aprobar el staff:', error);
            this.toast.error('Error al aprobar al usuario.');
        }
    },


    updateStaffMember(staffId, updates, category) {
        const groupIndex = this.groups.findIndex(group => 
            group.staff_members[category].some(member => member.staff_id === staffId)
        );
        if (groupIndex !== -1) {
            const memberIndex = this.groups[groupIndex].staff_members[category].findIndex(member => member.staff_id === staffId);
            if (memberIndex !== -1) {
                // Direct assignment in Vue 3
                this.groups[groupIndex].staff_members[category][memberIndex] = {
                    ...this.groups[groupIndex].staff_members[category][memberIndex],
                    ...updates
                };
            }
        }
    },

   // Componente padre
    handleUserDeleted({ userId, groupId }) {
    this.groups = this.groups.map(group => {
        if (group.group_id === groupId) {
        group.users = group.users.filter(user => user.id_token !== userId);
        }
        return group;
    });
    },

    handleGroupDeleted(groupId) {
      this.groups = this.groups.filter(group => group.group_id !== groupId);
    },
    async validateRole() {
    

      if (!this.roleToken) {
        this.roleLoaded = true;
        return;
      }
      try {
        const response = await axios.post('/api/verify-role', {
          roleToken: this.roleToken
        });
    
        this.role = response.data.role;
      } catch (error) {
        // console.error('Error verifying role:', error);
        this.role = null;
      } finally {
        this.roleLoaded = true;
      }
    },
    canView(...expectedRoles) {
        if (!this.roleLoaded) {
            return false;
        }
        const roleHierarchy = {
            'usuario': 1,
            'administrador': 2,
            'administradorevento': 3,
            'superadministrador': 4
        };

        return expectedRoles.some(role => roleHierarchy[this.role] >= roleHierarchy[role]);
    }
  },
  mounted() {
    this.validateRole();
    this.fetchGroups();
  }
}
</script>


<style scoped>
.container {
  flex-direction: column;
}
.botones {
  width: 350px;
}
.titulo-grupo {
  display: flex;
  align-items: center;
  div {
    margin-right: 20px;
  }
}

.bg-green-500 { background-color: #10b981; }
.hover:bg-green-700:hover { background-color: #059669; }
.bg-blue-500 { background-color: #3b82f6; }
.hover:bg-blue-700:hover { background-color: #1e40af; }

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  padding: 10px;
  margin: 0 5px;
  background-color: #efefef;
  border: none;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.boton-svg {
    display: flex;
    justify-content: center;
}
.modal-trigger-button {
    background: transparent;
    border: none;
    cursor: pointer;
    /* border: 1px solid #000; */
    padding: 15px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 0 8px rgba(0,0,0,0.7);
    position: fixed;
    z-index: 30;
    top: 7px;
    left: auto;
    right: auto;
    /* margin: auto; */
    transition: all 0.2s;
}
.modal-trigger-button:hover{
    background: #2959a6;
    box-shadow: 0 0 8px rgba(255,255,255,0.7);
    
}
.modal-trigger-button:hover svg{
    fill: #fff;    
}

.modal-trigger-button svg {
    transition: all 0.2s;
    fill: gray;
    transform: scale(2);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-content {
  /* background: white; */
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.7);
}

.boton-front{
    display: block;
    margin-bottom: 16px;
}
button svg {
    min-width: 20px;
}
.boton-tutorial {
  /* position: absolute; */
  display: flex;  
  right: 20px;
  z-index: 3;
  position: fixed;
  z-index: 30;
  top: 14px;
  left: auto;
  
}
.boton-tutorial a {
  display: inline-block;
  padding: 5px 10px;
  background: rgb(230, 11, 11);
  color: #fff;
  border-radius: 10px;
}
button {
  background: rgb(61, 67, 91)!important;
}
</style>
